module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.statistics) ? _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card--content"
  }, [_c('div', {
    staticClass: "card--number"
  }, [_c('div', {
    staticClass: "card--number-value"
  }, [_vm._v("\n        " + _vm._s(_vm.leadsCount) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "card--number-key"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('statistics.leads')) + "\n      ")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "card--diagram"
  }, [_c('div', {
    staticClass: "grid classification"
  }, [_c('div', {
    staticClass: "hot"
  }, [_c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.leadsHotCount))]), _vm._v("\n          " + _vm._s(_vm.$t('statistics.leads_hot')) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "warm"
  }, [_c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.leadsWarmCount))]), _vm._v("\n          " + _vm._s(_vm.$t('statistics.leads_warm')) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "cold"
  }, [_c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.leadsColdCount))]), _vm._v("\n          " + _vm._s(_vm.$t('statistics.leads_cold')) + "\n        ")])])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b5f96b7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/projects/ProjectStatisticsLeadsClassification.vue
// module id = 1850
// module chunks = 0